// extracted by mini-css-extract-plugin
export var cell = "index-module--cell--dZ64H";
export var container = "index-module--container--y33SA";
export var icon = "index-module--icon--K8A-q";
export var large = "index-module--large--1ME3D";
export var normal = "index-module--normal--Feo2F";
export var p = "index-module--p--NRT1W";
export var selectContainer = "index-module--selectContainer--vY8zk";